module.exports = __webpack_public_path__ + "static/Cloudimage-a8f9eb64212bd00288118bdaebba455d.svg";